'use client';

import { useEffect, useState } from 'react';
import ServiceHero from './ServiceHero';

const ServicesInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const heroData = {
    title: 'Your Complete Resource Hub',
    subtitle: '',
    description:
      'As your parts supplier, we know having the right information is just as important as having the right components. This section gives you quick access to service manuals, wiring diagrams, training materials, and support. Everything you need to keep your equipment running smoothly and your install on time.',
  };

  const resourceSections = [
    {
      title: 'Service Manuals',
      description:
        'Find the documentation you need for proper operation, maintenance, and troubleshooting across our product lines.',
    },
    {
      title: 'Wiring Schematics',
      description:
        'Access clear, accurate electrical diagrams to ensure proper installation and service.',
    },
    {
      title: 'Service & Support Requests',
      description:
        'Need assistance? Submit a request and our team will help identify issues, locate the correct parts, or guide you through the next steps.',
    },
    {
      title: 'Installation & Training Videos',
      description:
        'Step-by-step visual guides to help you install, configure, and service your equipment with confidence.',
    },
    {
      title: 'FAQ',
      description:
        'Quick answers to common questions about parts, compatibility, orders, and support.',
    },
  ];

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="animate-pulse">
          <div className="h-[60vh] bg-muted" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <ServiceHero
        title={heroData?.title}
        subtitle={heroData?.subtitle}
        description={heroData?.description}
      />

      {/* Resource Sections Grid */}
      <section className="px-6 lg:px-12 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {resourceSections?.map((section, index) => (
              <div
                key={index}
                className="bg-card border border-border rounded-lg p-8 hover:border-primary transition-colors duration-300"
              >
                <h3 className="text-2xl font-headline font-bold text-primary mb-4">
                  {section?.title}
                </h3>
                <p className="text-base font-body text-text-secondary leading-relaxed">
                  {section?.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesInteractive;